import * as React from 'react'

interface Code {
  digit1: string
  digit2: string
  digit3: string
  digit4: string
}

interface CodeInputProps {
  handleChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    fieldName: keyof Code,
  ) => void
  code: Code
}

const CodeInput: React.FC<CodeInputProps> = ({ handleChange, code }) => {
  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    fieldName: keyof Code,
  ) => {
    handleChange(e, fieldName)
  }

  return (
    <div className="mb-3 flex w-full gap-3 pt-3">
      <input
        className="order-blue-500 h-[48px] w-[48px] text-center rounded-md border px-2 shadow-md focus:border-blue-600 focus:outline-none focus:ring-2"
        type="text"
        maxLength={1}
        value={code.digit1}
        onChange={(e) => handleInputChange(e, 'digit1')}
      />
      <input
        type="text"
        maxLength={1}
        value={code.digit2}
        onChange={(e) => handleInputChange(e, 'digit2')}
        className=" order-blue-500 h-[48px] w-[48px] text-center rounded-md border px-2 shadow-md focus:border-blue-600 focus:outline-none focus:ring-2"
      />
      <input
        type="text"
        maxLength={1}
        value={code.digit3}
        onChange={(e) => handleInputChange(e, 'digit3')}
        className="order-blue-500 h-[48px] w-[48px] text-center rounded-md border px-2 shadow-md focus:border-blue-600 focus:outline-none focus:ring-2"
      />
      <input
        type="text"
        maxLength={1}
        value={code.digit4}
        onChange={(e) => handleInputChange(e, 'digit4')}
        className="order-blue-500 h-[48px] w-[48px] text-center rounded-md border px-2 shadow-md focus:border-blue-600 focus:outline-none focus:ring-2"
      />
    </div>
  )
}

export default CodeInput
